export function resolveMediaUrl(sourceKey: string, basePath: string): string {
	if (sourceKey.startsWith("http")) {
		return sourceKey;
	}

	return `${basePath}/${sourceKey}`;
}
